import {PersonDto} from "../../client/person/PersonApiClient";

export default class PersonAnonymizer {
    static anonymizePerson(person: PersonDto): PersonDto {
        const anonymizedPerson = {...person};
        if (anonymizedPerson.firstName) {
            anonymizedPerson.firstName = this.anonymizeName(anonymizedPerson.firstName);
        }
        if (anonymizedPerson.lastName) {
            anonymizedPerson.lastName = this.anonymizeName(anonymizedPerson.lastName);
        }
        return anonymizedPerson;
    }

    static anonymizeName(name: string): string {
        if (name.length <= 1) {
            return name;
        }
        return name.charAt(0) + "*".repeat(name.length - 1);
    }

}
